export enum Key {
  Token = "Token",
  RefreshToken = "RefreshToken",
  TimeExpired = "TimeExpired",
  TimeSession = "TimeSession",
}
